import { render, staticRenderFns } from "./ProjectFolderActionsRename.vue?vue&type=template&id=0c7b45eb&lang=pug&"
import script from "./ProjectFolderActionsRename.vue?vue&type=script&lang=js&"
export * from "./ProjectFolderActionsRename.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFolderActionsRename.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports